// used in building of the routes, does the day have overnights,
// does they day start with and over night start and end woth overnight
// this determines how the route is built on the map
export enum DayOvernightTypes {
   NoOvernights,
   DayEndsInOvernight,
   DayStartsWithOvernight,
   DayStartsAndEndsWithOvernight
}
